import { getElementDeclarationFromBuilder } from "./getElementDeclarationFromBuilder.js";
import { isBuilder } from "./isBuilder.js";
import { isElementDeclaration } from "./other.js";
/**
 * Recursively extracts the element declaration tree from a builder.
 *
 * @remarks
 *
 * The resulting tree contains only the element declarations and their children,
 * which can are only element declarations or resolved children; i.e. no promises
 * or builders.
 */
export async function resolveDeclarationTree(input) {
    let declaration;
    if (isElementDeclaration(input)) {
        declaration = input;
    }
    else if (isBuilder(input)) {
        declaration = await getElementDeclarationFromBuilder(input);
    }
    else {
        throw new TypeError(`Expected a builder or an element declaration, but received: ${typeof input}`);
    }
    return {
        ...declaration,
        children: await Promise.all(declaration.children.map(declarationChildToTree)),
    };
}
async function declarationChildToTree(child) {
    if (isBuilder(child) ||
        isElementDeclaration(child)) {
        return resolveDeclarationTree(child);
    }
    return child;
}
